<template>
  <section class="video-section">
    <h1 class="fw-bold">{{ $t('Explore') }}</h1>
    <div class="custom-swiper">
      <swiper
        class="mb-5"
        ref="mySwiper"
        :slides-per-view="3"
        :space-between="20"
        :loop="true"
        :centered-slides="true"
        :autoplay="{ delay: 3000, disableOnInteraction: false }"
        :pagination="{ clickable: true }"
      >
        <swiper-slide
          v-for="(slide, index) in slides"
          :key="index"
          @click="openModal(slide)"
          :class="{ 'active-slide': activeIndex === index }"
        >
          <!-- Display thumbnail before clicking -->
          <img
            :src="getThumbnailUrl(slide.video)"
            alt="Video thumbnail"
            class="slide-thumbnail"
          />
        </swiper-slide>
      </swiper>

      <!-- Modal -->
      <div v-if="isModalOpen" class="modal" @click.self="closeModal">
        <div class="modal-content">
          <!-- Embed the clicked video for autoplay -->
          <iframe
            v-if="currentSlide"
            :src="getYouTubeEmbedUrl(currentSlide.video)"
            class="modal-video"
            frameborder="0"
            allow="autoplay; encrypted-media"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    slides: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeIndex: 0,
      isModalOpen: false,
      currentSlide: null,
      swiperInstance: null, // Track the Swiper instance
    };
  },
  mounted() {
    this.swiperInstance = this.$refs.mySwiper?.swiper || null;
  },
  methods: {
    openModal(slide) {
      this.currentSlide = slide;
      this.isModalOpen = true;

      if (this.swiperInstance) {
        this.swiperInstance.autoplay.stop();
      }
    },
    closeModal() {
      this.isModalOpen = false;
      this.currentSlide = null;

      if (this.swiperInstance) {
        this.swiperInstance.autoplay.start();
      }
    },
    getYouTubeEmbedUrl(videoUrl) {
      const videoId = this.extractYouTubeVideoId(videoUrl);
      return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    },
    extractYouTubeVideoId(url) {
      const match = url.match(
        /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([\w-]+)/
      );
      return match ? match[1] : null;
    },
    getThumbnailUrl(videoUrl) {
      const videoId = this.extractYouTubeVideoId(videoUrl);
      return videoId ? `https://img.youtube.com/vi/${videoId}/0.jpg` : "";
    },
  },
};
</script>

<style scoped>
.video-section {
  padding: 30px;
  background: #077747;
  position: relative;
  width: 100%;
  border-radius: 10px;
  max-width: 1500px;
  height: auto;
  margin: 0 auto;
}

.video-section h1 {
  margin: 20px 0;
  color: #ffffff;
  text-align: center;
}

.custom-swiper {
  position: relative;
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
}
.slide-thumbnail {
  width: 100%;
  height: 200px;
  border-radius: 10px;
  cursor: pointer;
  object-fit: cover;
  transition: transform 0.3s, opacity 0.3s;
}

.swiper-slide {
  opacity: 1;
  transform: scale(0.9);
}

.active-slide .slide-thumbnail {
  transform: scale(1.1);
  opacity: 1;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  max-width: 800px;
  width: 90%;
  background: #fff;
  border-radius: 10px;
  padding: 0.5px;
  position: relative;
}

.modal-video {
  width: 100%;
  height: 450px;
  border-radius: 10px;
}

.modal-content iframe {
  width: 100%;
  height: 450px;
  border-radius: 10px;
}
</style>
